export function validEmail(email = '') {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
}

export function validateRedirect(redirectUrl = '', baseUrl = '') {
    if (!redirectUrl) return false;

    const absolutePath = /^\/[a-zA-Z]+/.test(redirectUrl);

    if (absolutePath) return true;

    let hostMatch = false;

    try {
        const base = new URL(baseUrl);
        const url = new URL(redirectUrl);

        hostMatch = url.host === base.host;
    } catch (_error) {
        return false;
    }

    return hostMatch;
}
